import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentSettings from "../../myComp/ContentSettings";

class VideoGet extends PlusComponent {
  constructor(props) {
    super(props, "contentVideo");         
  }

  render(){     
    return (
        <div>
          <ContentSettings {...this.props} controller="contentVideo"></ContentSettings>
        </div>
      )
    }
}

export default VideoGet;